import './canadiansteakout/style';
import FormStructure from './canadiansteakout/form_structure';

export default FormStructure;